import { render } from "./ShipmentViewPaymentMethod.vue?vue&type=template&id=e400cacc&scoped=true"
import script from "./ShipmentViewPaymentMethod.vue?vue&type=script&lang=js"
export * from "./ShipmentViewPaymentMethod.vue?vue&type=script&lang=js"

import "./ShipmentViewPaymentMethod.vue?vue&type=style&index=0&id=e400cacc&lang=scss&scoped=true"

import exportComponent from "/home/www/omniauto/omniadmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e400cacc"]])

export default __exports__